const LOWEST_IOS_VERSION = 17;
const LOWEST_ANDROID_VERSION = 14;
// Recording Sentry replays negatively affects performance. To avoid making already slow devices
// _even_ slower, we use the OS version as a threshold for eligibility, since very old devices
// do not have access to newer OS versions.
export const isEligibleForReplays = (os) => {
    // Shaves of any minor or bug versions
    const parsedVersion = parseInt(os.version, 10);
    switch (os.name) {
        case 'iOS':
            return parsedVersion >= LOWEST_IOS_VERSION;
        case 'Android':
            return parsedVersion >= LOWEST_ANDROID_VERSION;
        default:
            return false;
    }
};
